import {
  AssetRequestCreateInput,
  AssetRequestType,
} from '@atom/types/assetRequest';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

// TODO: [AM-16707]: Temp code until BE solution is built
export type TotalRemainingState = {
  totalRemaining: number;
  fromTotalRemaining: number;
  totalRemainingLoading: boolean;
  fromTotalRemainingLoading: boolean;
};

// Returns true while the SDDOT create form is incomplete or would leave an
// asset with negative stock. Keyed by request type; other types are never
// disabled here.
export const getSDDOTCreateDisabled = (
  createInputs: AssetRequestCreateInput,
  totals: TotalRemainingState,
): boolean => {
  const {
    replenishment,
    quantityOrdered,
    quantity,
    reason,
    fromAssetId,
    assignedTo,
    comments,
  } = createInputs;

  const {
    totalRemaining,
    fromTotalRemaining,
    totalRemainingLoading,
    fromTotalRemainingLoading,
  } = totals;

  const inventoryTransferDifference =
    Number(fromTotalRemaining) - Number(quantityOrdered);
  const stockpileTransferDifference =
    Number(fromTotalRemaining) - Number(quantity);
  const adjustmentUpdatedQuantity = Number(totalRemaining) + Number(quantity);

  // const inventoryTransferDifference =
  //   Number(selectedFromAsset?.budget?.quantityOnHand) -
  //   Number(quantityOrdered);
  // const stockpileTransferDifference =
  //   Number(selectedFromAsset?.budget?.quantityOnHand) - Number(quantity);
  // const adjustmentUpdatedQuantity =
  //   Number(asset?.budget?.quantityOnHand) + Number(quantity);

  const disabledRules = {
    [AssetRequestType.SDDOT_INVENTORY_TRANSFER]:
      totalRemainingLoading ||
      fromTotalRemainingLoading ||
      isNilOrEmpty(fromAssetId) ||
      isNilOrEmpty(quantityOrdered) ||
      inventoryTransferDifference < 0 ||
      isNilOrEmpty(assignedTo),
    [AssetRequestType.SDDOT_STOCKPILE_TRANSFER]:
      totalRemainingLoading ||
      fromTotalRemainingLoading ||
      isNilOrEmpty(fromAssetId) ||
      isNilOrEmpty(quantity) ||
      stockpileTransferDifference < 0,
    [AssetRequestType.SDDOT_ADJUSTMENT]:
      totalRemainingLoading ||
      isNilOrEmpty(quantity) ||
      adjustmentUpdatedQuantity < 0 ||
      isNilOrEmpty(reason) ||
      isNilOrEmpty(comments),
    [AssetRequestType.SDDOT_REPLENISHMENT]:
      isNilOrEmpty(quantityOrdered) ||
      isNilOrEmpty(replenishment?.invoiceNumber) ||
      isNilOrEmpty(replenishment?.dateReceived) ||
      isNilOrEmpty(replenishment?.quantityReceived) ||
      isNilOrEmpty(replenishment?.unitCost) ||
      isNilOrEmpty(replenishment?.totalCost),
  };

  return disabledRules[createInputs?.type] ?? false;
};
